import LivePublisherComponent from "./LivePublisherComponent";

export default LivePublisherComponent;